@if (performanceMessages.length > 0 || hasConfigurationErrorAlerts) {
  <apm-performance-alerts-icon
    [fillHeight]="true"
    [messages]="performanceMessages"
    [additionalErrorMessagesCount]="additionalErrorMessagesCount"
    (showMessages)="showMessagesDetails($event)"
  ></apm-performance-alerts-icon>
} @else {
  <div class="content">
    {{ value }}
  </div>
}
